import React from "react";
import { Modal } from "antd";

/**
 * Shown when the only human in an AI+agent chat is leaving, so the visit can be
 * fully ended and moved to past conversations.
 */
export default function EndChatWithAiSessionModal({ open, onCancel, onConfirm, visitorName }) {
  return (
    <Modal
      open={open}
      title="End this chat for the visitor?"
      okText="Yes, end chat"
      cancelText="No, stay"
      onCancel={onCancel}
      onOk={onConfirm}
      destroyOnClose
    >
      <p>
        {visitorName
          ? `This will end the session for ${visitorName} and the AI assistant. The conversation will be closed and moved to history.`
          : "This will end the session for the visitor and the AI assistant. The conversation will be closed and moved to history."}
      </p>
      <p style={{ marginBottom: 0, color: "var(--ant-color-text-secondary, #666)" }}>
        The visitor can start a new chat from the widget at any time.
      </p>
    </Modal>
  );
}
